@if (invalid()) {
    <p class="iackathon-group__invalid-save-message">
        {{ errorKey() | translate }}
        @if (ownerUsername()) {
            ({{ ownerUsername() }})
        }
        @if (save().id) {
            #{{ save().id }}
        }
    </p>
} @else if (outdated()) {
    <p class="iackathon-group__outdated-save-message">
        {{ 'iackathon.outdated_save' | translate }} ({{ ownerUsername() }})
    </p>
} @else {
    <div class="iackathon-group__header">
        <h2 class="iackathon-group__title">
            {{ groupName() }}
        </h2>
        <div class="iackathon-group__progress"
             role="progressbar"
             aria-valuemin="0"
             aria-valuemax="4"
             [attr.aria-valuenow]="indexCurrentPhase()"
             [attr.aria-label]="'generic.progress' | translate">
            @for (step of [1, 2, 3, 4]; track step) {
                <div class="iackathon-group__progress-step"
                     [class.iackathon-group__progress-step--current]="indexCurrentPhase() === step"
                     [class.iackathon-group__progress-step--completed]="indexCurrentPhase() > step"
                     aria-hidden="true">
                </div>
            }
        </div>
    </div>
    <section class="iackathon-group__user-section">
        <h3 class="iackathon-group__author">
            {{ 'iackathon.group_of' | translate }} {{ saveAuthor() }}
        </h3>
        <ul class="iackathon-group__member-list">
            @for (member of members(); track member) {
                <li class="iackathon-group__member-item">
                    <span>{{ member.name }}</span>
                    <span>{{ $last ? null : ', ' }}</span>
                </li>
            }
        </ul>
    </section>
    <div class="iackathon-group__actions">
        <a class="iackathon-group__action-link"
           [routerLink]="['/iackathon-groups', save().id]">
            {{ 'iackathon.show_group' | translate }}
        </a>
        <a class="iackathon-group__action-link"
           [routerLink]="hasDeliverable() ? ['/iackathon-deliverables', save().id] : null"
           [attr.aria-disabled]="hasDeliverable() ? null : 'true'">
            {{ 'iackathon.deliverable' | translate }}
        </a>
    </div>
}
